import React, { Component } from 'react';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';

import RankingIcon from '../../icons/RankingIcon';

const SortableItem = SortableElement(({ value, i }) =>
  <li className="new-assessment-detail__ranking-item">
    <span className="new-assessment-detail__ranking-numeral">
      {i + 1}
    </span>
    <RankingIcon />
    {value}
  </li>
);

const SortableList = SortableContainer(({ items }) => (
  <ul className="new-assessment-detail__ranking">
    {items.map((value, index) => (
      <SortableItem
        key={value.id}
        index={index}
        value={value.label}
        i={index} // unfortunately we can't use the index that's already there
      />
    ))}
  </ul>
));

class QuestionRanking extends Component {
  onSortStart = () => {
    this.bodyDOM.classList.add('react-sortable-hoc-dragging');
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    this.bodyDOM.classList.remove('react-sortable-hoc-dragging');
    // rearrange array
    const newItems = arrayMove(this.sortedOptions, oldIndex, newIndex);
    // then reduce it to an object
    const parts = newItems.reduce((parts, item, index) => {
      parts[item.id] = index;
      return parts;
    }, {})
    this.props.onChange(parts);
  };

  render() {
    this.bodyDOM = document.querySelector('body');
    this.sortedOptions = Object.keys(this.props.currentAnswers.parts).length === 0
      ? this.props.parts
      : Object.entries(this.props.currentAnswers.parts)
        .sort((a, b) => a[1] - b[1]) // sort by value (index)
        .map(([key, index]) => this.props.parts.find(part => part.id === parseInt(key, 10)));
    return (
      <SortableList
        items={this.sortedOptions}
        lockAxis="y"
        lockToContainerEdges
        onSortStart={this.onSortStart}
        onSortEnd={this.onSortEnd}
      />
    );
  }
}

export default QuestionRanking;



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionRanking.js